<template>
    <component :is="glyphComponent" class="glyph-container" />
</template>

<script setup>
import { computed } from 'vue';
import { GlyphType } from '../../composables/useConstants';
import {
    AlertGlyphIcon,
    AltitudeGlyphIcon,
    ArrowGlyphIcon,
    BackGlyphIcon,
    ChevronGlyphIcon,
    CloseGlyphIcon,
    CollapseGlyphIcon,
    CollapseTinyGlyphIcon,
    CoordsGlyphIcon,
    CoordsSelectedGlyphIcon,
    ExpandGlyphIcon,
    ExpandTinyGlyphIcon,
    ExternalGlyphIcon,
    InfoGlyphIcon,
    LightboxGlyphIcon,
    LocationGlyphIcon,
    LocationJumpToGlyphIcon,
    LocationPillGlyphIcon,
    MenuGlyphIcon,
    PlusGlyphIcon,
    ProGlyphIcon,
    SuccessGlyphIcon,
    LayersGlyphIcon,
} from 'ihunter-pathfinder-components';

const props = defineProps({
    type: {
        type: String,
        required: true,
        validator: (value) => {
            return Object.values(GlyphType).includes(value);
        },
    },
});

const glyphMap = {
    [GlyphType.Alert]: AlertGlyphIcon,
    [GlyphType.Altitude]: AltitudeGlyphIcon,
    [GlyphType.Arrow]: ArrowGlyphIcon,
    [GlyphType.Back]: BackGlyphIcon,
    [GlyphType.Chevron]: ChevronGlyphIcon,
    [GlyphType.Close]: CloseGlyphIcon,
    [GlyphType.Collapse]: CollapseGlyphIcon,
    [GlyphType.CollapseTiny]: CollapseTinyGlyphIcon,
    [GlyphType.Coords]: CoordsGlyphIcon,
    [GlyphType.CoordsSelected]: CoordsSelectedGlyphIcon,
    [GlyphType.Expand]: ExpandGlyphIcon,
    [GlyphType.ExpandTiny]: ExpandTinyGlyphIcon,
    [GlyphType.External]: ExternalGlyphIcon,
    [GlyphType.Info]: InfoGlyphIcon,
    [GlyphType.Lightbox]: LightboxGlyphIcon,
    [GlyphType.Location]: LocationGlyphIcon,
    [GlyphType.LocationJumpTo]: LocationJumpToGlyphIcon,
    [GlyphType.LocationPill]: LocationPillGlyphIcon,
    [GlyphType.Menu]: MenuGlyphIcon,
    [GlyphType.Plus]: PlusGlyphIcon,
    [GlyphType.Pro]: ProGlyphIcon,
    [GlyphType.Success]: SuccessGlyphIcon,
    [GlyphType.Layers]: LayersGlyphIcon,
};

const glyphComponent = computed(() => {
    return glyphMap[props.type] || null;
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.glyph-container {
    display: flex;
    width: Pathfinder.$icon-micro;
    height: Pathfinder.$icon-micro;
}
</style>
